import type * as React from "react";

import { EmptyState, PageFrame } from "@don/design-system";

import { SESSIONS, navigate } from "../routing/route.js";

/**
 * A page that leads nowhere (issue 199, screen-catalog S6 and `session-not-found`): the page
 * frame, a title, one sentence and `Go to Sessions`, the empty-state layout. Not found and a
 * session you cannot open are this one layout with different words.
 */
export function LeadsNowhere({
  title,
  body,
  ...hooks
}: { title: string; body: React.ReactNode } & Record<`data-${string}`, string>) {
  return (
    <div {...hooks} style={{ flex: 1, minHeight: 0, overflow: "auto" }}>
      <PageFrame>
        <EmptyState
          flush
          title={title}
          body={body}
          primary={{ children: "Go to Sessions", onClick: () => navigate(SESSIONS) }}
        />
      </PageFrame>
    </div>
  );
}

/** Any path the Console has no page for. The path is shown in ink-1 (catalog S6). */
export function NotFound({ path }: { path: string }) {
  return (
    <LeadsNowhere
      data-not-found={path}
      title="Page not found"
      body={
        <>
          There's no page at <span style={{ color: "var(--ink-1)" }}>{path}</span>
        </>
      }
    />
  );
}
